var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg6Tablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 1195,
    viewBox: "0 0 770 1195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_94487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.068,
    cy: 358.277,
    rx: 245.068,
    ry: 358.277,
    transform: "matrix(0.675407 0.737445 -0.660499 0.750827 586.359 610.17)",
    fill: "url(#paint0_linear_447_94487)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_447_94487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.068,
    cy: 358.277,
    rx: 245.068,
    ry: 358.277,
    transform: "matrix(0.675407 0.737445 -0.660499 0.750827 692.695 317)",
    fill: "url(#paint1_linear_447_94487)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_94487",
    x: 26.4297,
    y: 535.789,
    width: 977.617,
    height: 1048.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_447_94487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_447_94487",
    x: 52.7656,
    y: 162.619,
    width: 1137.62,
    height: 1208.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 140,
    result: "effect1_foregroundBlur_447_94487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_94487",
    x1: 245.068,
    y1: 0,
    x2: 245.068,
    y2: 716.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_447_94487",
    x1: 245.068,
    y1: 0,
    x2: 245.068,
    y2: 716.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg6Tablet);
export default __webpack_public_path__ + "static/media/bg6-tablet.5f038f13902d00c5f9f162b8c10d9c6e.svg";
export { ForwardRef as ReactComponent };